module.exports = __webpack_public_path__ + "img/title2.88b5395e.png";